/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Delivery_Address_LabelInputs */

const vi_pos_delivery_address_label = /** @type {(inputs: Pos_Delivery_Address_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ giao hàng`)
};

/**

* @param {Pos_Delivery_Address_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_delivery_address_label = /** @type {((inputs?: Pos_Delivery_Address_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Delivery_Address_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_delivery_address_label(inputs)
});